jQuery(document).ready(function () {
    jQuery(document).on("click", ".rebuy-button, .rebuy-button span", function () {
        var interval = setInterval(doStuff, 100);
        function doStuff() {
            if (!jQuery(".rebuy-button").hasClass("working")) {
                fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
                    const cartid = 'CartDrawer'; const html = new DOMParser().parseFromString(responseText, 'text/html') 
                    const destination = document.querySelector('#CartDrawer'); const source = html.getElementById(cartid); 
                    if (source && destination) destination.innerHTML = source.innerHTML;
                    jQuery.ajax({
                        url: '/?section_id=cart-icon-bubble', type: 'GET', dataType: 'html', success: function (itemcount) {
                            jQuery("#cart-icon-bubble").html(jQuery(itemcount).html()); jQuery(".cart-count-bubble").trigger("click");
                        }
                    });
                });
                clearInterval(interval);
            }
        }
    });
});

let observerQuiz = new MutationObserver(checkForQuiz);
const config = { childList: true, subtree: true };
observerQuiz.observe(document.body, config);
function checkForQuiz() {
  let element = document.querySelector("#tangent-iframe-div p:last-child");
  if (element) {
    observerQuiz.disconnect(); // Stop the MutationObserver
    hideQuizBrand();
  }
} 
function hideQuizBrand() {
  document.querySelector("#tangent-iframe-div p:last-child").style.display="none"
}
